import { useDataTableFilters } from './use-data-table-filters';
import { useDataTableList } from './use-data-table-list';
import { useDataTablePagination } from './use-data-table-pagination';
import { useDataTableSort } from './use-data-table-sort';

interface UseDataTableOptions {
  numberOfItemsPerPageList?: number[];
  defaultField?: string;
  defaultDirection?: 'asc' | 'desc';
}
export const useDataTable = <T>(
  data: T[] = [],
  options?: UseDataTableOptions
) => {
  const sort = useDataTableSort({
    defaultField: options?.defaultField,
    defaultDirection: options?.defaultDirection,
  });
  const filters = useDataTableFilters();

  const { list: filteredList = [] } = useDataTableList(data, {
    sort,
    filters,
  });

  const pagination = useDataTablePagination(
    filteredList,
    options?.numberOfItemsPerPageList
  );

  return {
    ...pagination,
    ...sort,
    ...filters,
  };
};
